// @flow

import { hpfetch } from '../util';
import type {
  wrappedApiResponseType,
  djangoModelApiResponse,
} from '../apiTypes';
import type { walletType, withdrawalType } from '../../types';

export const get = (): Promise<wrappedApiResponseType<walletType>> =>
  hpfetch('wallet/');

export const history = (
  limit: number = 100,
  offset: number = 0,
): Promise<wrappedApiResponseType<any>> =>
  hpfetch(`wallet/history/?limit=${limit}&offset=${offset}`);

export const getManyWithdrawals = (
  limit: number = 100,
  offset: number = 0,
): djangoModelApiResponse<withdrawalType> =>
  hpfetch(`wallet/withdrawals/?limit=${limit}&offset=${offset}`);

// amount, payment_method_id
export const startWithdrawal = (fields: any) =>
  hpfetch(`wallet/withdrawals/start/`, {
    method: 'POST',
    body: JSON.stringify(fields),
  });

export const csv = (): Promise<any> => hpfetch('wallet/history_csv/');

export const pdf = (): Promise<any> => hpfetch('wallet/history_pdf/');

export const rewardWalletLinkClick = () =>
  hpfetch(`rewards/wallet-link-click/claim/`, {
    method: 'POST',
  });
